import styled from 'styled-components'

export default styled.span`
  color: #03a9f4;
  font-size: 45px;
  font-weight: 100;
  text-align: center;
`
